import { render, staticRenderFns } from "./UploadScreenSaver.vue?vue&type=template&id=41f15c64&"
import script from "./UploadScreenSaver.vue?vue&type=script&lang=js&"
export * from "./UploadScreenSaver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports